import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Pipeline } from '@vendasta/sales-common';

export const PIPELINE_SETTINGS_CONFIG_TOKEN = new InjectionToken<PipelineSettingsConfig>(
  'general dependency data for pipeline settings',
);

export interface PipelineSettingsConfig {
  partnerId$: Observable<string>;
  currentPipeline$: Observable<Pipeline>;
}
